// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StagePill — mono uppercase stage label with a tone dot. */
.stagepill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-secondary);
}
.stagepill .st__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: currentColor;
  flex: none;
}
.stagepill--mute {
  color: var(--text-muted);
}
.stagepill--info {
  color: var(--info);
}
.stagepill--ready {
  color: var(--accent);
}
.stagepill--warn {
  color: var(--warn);
}
.stagepill--danger {
  color: var(--danger);
}
.stagepill--ok {
  color: var(--ok);
}
.stagepill--live {
  color: #1090ba;
}
`, "",{"version":3,"sources":["webpack://./src/ui/StagePill/StagePill.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB","sourcesContent":["/* StagePill — mono uppercase stage label with a tone dot. */\n.stagepill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n.stagepill .st__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: currentColor;\n  flex: none;\n}\n.stagepill--mute {\n  color: var(--text-muted);\n}\n.stagepill--info {\n  color: var(--info);\n}\n.stagepill--ready {\n  color: var(--accent);\n}\n.stagepill--warn {\n  color: var(--warn);\n}\n.stagepill--danger {\n  color: var(--danger);\n}\n.stagepill--ok {\n  color: var(--ok);\n}\n.stagepill--live {\n  color: #1090ba;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
